import { MutationTree } from "vuex";
import { IDepartment } from "@/core/interfaces/department.interface";
import { IDepartmentState } from "../types";

const mutations: MutationTree<IDepartmentState> = {
  setDepartments(state, payload: IDepartment[]) {
    state.departments = payload;
  },
  setFetchingDepartments(state, payload: boolean) {
    state.isFetchingDepartments = payload;
  },
  setDepartmentActionLoading(state, payload: boolean) {
    state.departmentActionLoading = payload;
  },
};

export default mutations;
